module.exports = __webpack_public_path__ + "media/images/flags/32/Dominican-Republic-2e450dd0ba4a9a286d0131f5a3f72c22.png";